import Slider from 'rc-slider'
import React, { useContext, useState } from 'react'

import { formatNumber, getStepValue } from '@js/common/utils'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import QuestionHeading from '@f/applications/QuizApp/partials/QuestionHeading'

const QuestionSlider = ({ step }) => {
  const context = useContext(QuizContext)

  const formatValue = ({ name, sliderValue, valueSuffix, valuePrefix }) => {
    const maxValue = step.sliders.find(slider => slider.name === name).maxValue

    return sliderValue === 0
      ? 'Keine Angabe'
      : `${sliderValue > maxValue - 1 ? '> ' : ''}${
          valuePrefix ? `${valuePrefix} ` : ''
        }${formatNumber(sliderValue, 0, ',', '.')}${
          valueSuffix ? ` ${valueSuffix}` : ''
        }`
  }

  const SliderElement = ({
    name,
    label,
    minValue,
    maxValue,
    valueStep,
    valueSuffix,
    valuePrefix,
    value = 0
  }) => {
    const [sliderValue, setSliderValue] = useState(value)

    const handleSliderMove = value => {
      setSliderValue(value)
    }

    const handleSliderDrop = value => {
      context.actions.updateValues({
        stepID: step.id,
        valuesToSave: [
          {
            name: name,
            value: value
          }
        ]
      })
    }

    return (
      <div className='[ f-pos-rel f-m-t-030 f-m-h-auto f-c-ba-whi f-radius-card-large f-shadow-strong ] QuizApp-long-card'>
        <div className='FormSlider-value-tooltip-range'>
          <div
            className='[ f-pos-rel f-p-t-020 f-p-b-030 ] FormSlider-value-tooltip-wrapper'
            style={{
              width: `${
                sliderValue > minValue
                  ? ((sliderValue - minValue) * 100) / (maxValue - minValue)
                  : 0
              }%`
            }}>
            <span className='[ f-pos-ab f-t-mini f-c-fo-whi f-p-v-005 f-p-h-010 ] FormSlider-value-tooltip'>
              {formatValue({
                name,
                sliderValue: sliderValue,
                valueSuffix,
                valuePrefix
              })}
            </span>
          </div>
        </div>
        <Slider
          value={sliderValue}
          min={minValue}
          max={maxValue}
          step={valueStep ? valueStep : (maxValue - minValue) * 0.04}
          onChange={handleSliderMove}
          onAfterChange={handleSliderDrop}
          className='FormSlider'
        />
        <div className='[ f-p-t-010 f-p-h-030 f-p-b-040 f-d-flr ]'>
          <span className='[ f-t-micro f-c-fo-mut f-t-left f-fl-expand ]'>
            {minValue > 0
              ? `${
                  valuePrefix ? `${valuePrefix} ` : ''
                }${minValue.toLocaleString('DE-de')}${
                  valueSuffix ? ` ${valueSuffix}` : ''
                }`
              : 'Keine Angabe'}
          </span>
          <span className='[ f-t-micro f-c-fo-mut f-t-centre f-fl-expand ]'>
            {valuePrefix ? `${valuePrefix} ` : ''}
            {((maxValue + minValue) / 2).toLocaleString('DE-de')}
            {valueSuffix ? ` ${valueSuffix}` : ''}
          </span>
          <span className='[ f-t-micro f-c-fo-mut f-t-right f-fl-expand ]'>
            &gt; {valuePrefix ? `${valuePrefix} ` : ''}
            {maxValue.toLocaleString('DE-de')}
            {valueSuffix ? ` ${valueSuffix}` : ''}
          </span>
        </div>
        {label && (
          <div className='[ f-c-ba-bac015 f-t-body f-p-a-020 f-c-fo-neu200 f-t-centre f-radius-card-large-bottom f-t-bold ] QuizApp-long-card-label'>
            {label}
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <QuestionHeading heading={step.heading} subheading={step.subheading} />
      <div className='[ f-wrap ]'>
        {step.sliders.map(slider => (
          <SliderElement
            key={`quiz_slider_${slider.name}`}
            {...slider}
            value={getStepValue(step, slider.name)}
          />
        ))}
      </div>
    </>
  )
}

export default QuestionSlider
